<mat-chip-listbox [class]="stacked ? 'mat-mdc-chip-set-stacked' : ''">
  @for (item of items; track item) {
    <mat-chip-option
      [selected]="item.selected"
      [selectable]="item.selectable"
      [disabled]="!item.selectable && !item.selected"
      (click)="selectItem(item)"
      [ngClass]="{'chip': true, 'chip-hidden': !item.selectable && !item.selected}">
      {{ item.name }}
    </mat-chip-option>
  }
</mat-chip-listbox>